import React, { useState } from "react";
import { useLiveSearch, estimateTzOffsetMin } from "../lib/geocode";

/* Type-any-place-name search box backed by live OpenStreetMap (Nominatim)
   results — replaces the old bundled-city-list-only search. Selecting a
   result fires onSelect with { name, lat, lon, tzOffsetMin }, matching the
   shape the bundled city list used to provide. */
export default function LiveLocationSearch({ placeholder, className, onSelect, t }) {
  const [query, setQuery] = useState("");
  const { results, loading } = useLiveSearch(query);

  const pick = (r) => {
    onSelect({ name: r.label, lat: r.lat, lon: r.lon, tzOffsetMin: estimateTzOffsetMin(r.lon) });
    setQuery("");
  };

  return (
    <div className="live-loc-search-wrap">
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder={placeholder}
        className={className}
        autoComplete="off"
      />
      {loading && <div className="live-loc-search-status">{t("locSearching")}</div>}
      {!loading && results.length > 0 && (
        <ul className="live-loc-search-results">
          {results.map((r, i) => (
            <li key={`${r.label}-${i}`} onClick={() => pick(r)}>{r.label}</li>
          ))}
        </ul>
      )}
      {!loading && query.trim().length >= 3 && results.length === 0 && (
        <div className="live-loc-search-empty">{t("locSearchNoResults")}</div>
      )}
    </div>
  );
}
